 <template>
  <va-modal
    class="flex lg12 xs12 md12"
    v-model="filterFormsModal"
    size="large"
    title="Filters"
    message="Select Desired Filters"
    hideDefaultActions
    noOutsideDismiss
  >
    <va-search
      @pageChanged="submit($event,true)"
      :showTableBody="showTableBody"
      :info="paginationInfo"
    >
      <template v-slot:tableHeaders>
        <th style="width:25%">
          <va-input label="Form Title" v-model="criteria.formTitle"></va-input>
        </th>

        <th style="width:25%;">
          <va-date-picker
            label="Date From"
            :config="{dateFormat:'d/m/Y'}"
            v-model="criteria.createdDate"
          />
        </th>
        <th style="width:25%">
          <va-date-picker
            label="Date To"
            :config="{dateFormat:'d/m/Y'}"
            v-model="criteria.expirationDate"
          />
        </th>
        <th class="flex md4">
          <va-select
            label="Fetch Mode"
            v-model="criteria.fetchMode"
            keyBy="id"
            textBy="mode"
            :options="fetchOptions"
          ></va-select>
        </th>

        <th>
          <va-select
            v-model="perPage"
            :label="$t('tables.perPage')"
            :options="perPageOptions"
            keyBy="id"
            textBy="id"
          />
        </th>
      </template>

      <template :v-if="showTableBody" v-slot:tableBody>
        <tr
          class="content"
          style="cursor:pointer"
          v-for="(form,index) in filteredForms"
          @click="goToForm(form)"
          :key="index"
        >
          <td>{{form.formTitle}}</td>
          <td>{{form.createdDate}}</td>
          <td>{{form.expiredDate}}</td>
          <td></td>
        </tr>
      </template>
    </va-search>
    

      <div class="pull-right">
        <va-button @click="cancel">Cancel</va-button>
        <va-button @click="submit(false)">Submit</va-button>
      </div>
 
  </va-modal>
</template>

<script>
import formsService from "../ConsentFormsService.js";
import searchTemplate from "../../../app/SearchTemplate.vue"

export default {
  props: ["filterFormsModal"],
  data() {
    return {
      criteria: {
        formTitle: null,
        fetchMode: "ACTIVE",
        createdDate: null,
        expirationDate: null,
        page: 1,
        size: 1
      },
      total:1,
      perPage: { id: 10 },
      fetchOptions: [
        {
          id: 1,
          mode: "ACTIVE"
        },
        {
          id: 2,
          mode: "INACTIVE"
        },
        {
          id: 3,
          mode: "BOTH"
        }
      ]
    };
  },
  computed: {
    paginationInfo() {
      return {
        pageSize: this.criteria.size,
        total: this.total,
        resultLength: this.filteredForms.length
      };
    },
    showTableBody() {
      return !(this.filteredForms == null || this.filteredForms == "");
    },
    filteredForms() {
      return this.$store.getters.forms;
    },
    perPageOptions() {
      return [{ id: 10 }, { id: 25 }, { id: 50 }];
    }
  },
  methods: {
    submit(page, pageClick) {

      if (!pageClick) {
        this.page = 1;
      } else {
        this.criteria.page = page;
      }

      this.criteria.size=this.perPage.id
      formsService.filterForms(this.criteria).then(result => {
        let data = result.data;

        let forms = data.filterResults == undefined ? [] : data.filterResults;

        this.total = data.total;
        this.pageSize = data.pageSize;

        this.$store.dispatch("setFormArray", forms);
      });
    },
    goToForm(form) {
      this.clear();
      this.$store.dispatch("setForm", form);
      // this.$emit("closeModal");
      this.$router.push({ name: "editForm", params: { id: form._id } });
    },
    cancel() {
      this.clear();
      this.$emit("closeModal");
    },
    clear() {
      this.criteria = {
        formTitle: null,
        fetchMode: "ACTIVE",
        createdDate: null,
        expirationDate: null
      };

      this.$store.dispatch("clearForms");
    },
   
  },
   components: {
      "va-search": searchTemplate
    }
};
</script>


<style scoped>
th {
  vertical-align: bottom;
}

.content tr:hover {
  background-color: darkcyan;
}
</style>